package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.formatString
import io.github.skeptick.libres.strings.getPluralizedString
import kotlin.Int
import kotlin.String

public class LibresFormatNCourses(
  private val forms: PluralForms,
  private val languageCode: String,
) {
  public fun format(number: Int, count: String): String = formatString(getPluralizedString(forms, languageCode, number), arrayOf(count))
}

public class LibresFormatNCertificates(
  private val forms: PluralForms,
  private val languageCode: String,
) {
  public fun format(number: Int, count: String): String = formatString(getPluralizedString(forms, languageCode, number), arrayOf(count))
}

public class LibresFormatNAchievements(
  private val forms: PluralForms,
  private val languageCode: String,
) {
  public fun format(number: Int, count: String): String = formatString(getPluralizedString(forms, languageCode, number), arrayOf(count))
}

public class LibresFormatNYears(
  private val forms: PluralForms,
  private val languageCode: String,
) {
  public fun format(number: Int, count: String): String = formatString(getPluralizedString(forms, languageCode, number), arrayOf(count))
}
